// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { AskGetabstractAnswerContextDoc } from "../schema";

export function serialize_AskGetabstractAnswerContextDoc_internal(value: AskGetabstractAnswerContextDoc): unknown {
  return ((value: {
    bookmarked: boolean;
    dataId: number;
    rating: number | null;
    referenceNumber: number;
    snippet: string;
    sourceTypeString: string;
    title: string;
    urls: {
      cover: string;
      list: string;
      reference: string;
    };
  }): unknown => {
    return {
      bookmarked: ((value: boolean): unknown => {
        return value;
      })(value["bookmarked"]),
      dataId: ((value: number): unknown => {
        return value;
      })(value["dataId"]),
      rating: ((value: number | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["rating"]),
      referenceNumber: ((value: number): unknown => {
        return value;
      })(value["referenceNumber"]),
      snippet: ((value: string): unknown => {
        return value;
      })(value["snippet"]),
      sourceTypeString: ((value: string): unknown => {
        return value;
      })(value["sourceTypeString"]),
      title: ((value: string): unknown => {
        return value;
      })(value["title"]),
      urls: ((value: { cover: string; list: string; reference: string }): unknown => {
        return {
          cover: ((value: string): unknown => {
            return value;
          })(value["cover"]),
          list: ((value: string): unknown => {
            return value;
          })(value["list"]),
          reference: ((value: string): unknown => {
            return value;
          })(value["reference"]),
        };
      })(value["urls"]),
    };
  })(value);
}
export function serialize_AskGetabstractAnswerContextDoc(obj: AskGetabstractAnswerContextDoc): string {
  return renderJsonWithNumbersAsBigint(serialize_AskGetabstractAnswerContextDoc_internal(obj));
}
export function deserialize_AskGetabstractAnswerContextDoc_internal(value: unknown): ParserResult<AskGetabstractAnswerContextDoc> {
  return ((
    value: unknown,
  ): ParserResult<{
    bookmarked: boolean;
    dataId: number;
    rating: number | null;
    referenceNumber: number;
    snippet: string;
    sourceTypeString: string;
    title: string;
    urls: {
      cover: string;
      list: string;
      reference: string;
    };
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "bookmarked")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/bookmarked]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'bookmarked'.` };
    }
    const parsed_bookmarked = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/bookmarked]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["bookmarked"]);
    })();
    if (!parsed_bookmarked.success) {
      return { success: false, reason: parsed_bookmarked.reason };
    }
    if (!hasProp(value, "dataId")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/dataId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'dataId'.` };
    }
    const parsed_dataId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/dataId]: '${value}' expected to be of type number.` };
      })(value["dataId"]);
    })();
    if (!parsed_dataId.success) {
      return { success: false, reason: parsed_dataId.reason };
    }
    if (!hasProp(value, "rating")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/rating]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'rating'.` };
    }
    const parsed_rating = ((): ParserResult<number | null> => {
      return ((value: unknown): ParserResult<number | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/rating]: '${value}' expected to be of type number.` };
      })(value["rating"]);
    })();
    if (!parsed_rating.success) {
      return { success: false, reason: parsed_rating.reason };
    }
    if (!hasProp(value, "referenceNumber")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/referenceNumber]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'referenceNumber'.` };
    }
    const parsed_referenceNumber = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/referenceNumber]: '${value}' expected to be of type number.` };
      })(value["referenceNumber"]);
    })();
    if (!parsed_referenceNumber.success) {
      return { success: false, reason: parsed_referenceNumber.reason };
    }
    if (!hasProp(value, "snippet")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/snippet]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'snippet'.` };
    }
    const parsed_snippet = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/snippet]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["snippet"]);
    })();
    if (!parsed_snippet.success) {
      return { success: false, reason: parsed_snippet.reason };
    }
    if (!hasProp(value, "sourceTypeString")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/sourceTypeString]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'sourceTypeString'.` };
    }
    const parsed_sourceTypeString = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/sourceTypeString]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["sourceTypeString"]);
    })();
    if (!parsed_sourceTypeString.success) {
      return { success: false, reason: parsed_sourceTypeString.reason };
    }
    if (!hasProp(value, "title")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
    }
    const parsed_title = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/title]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["title"]);
    })();
    if (!parsed_title.success) {
      return { success: false, reason: parsed_title.reason };
    }
    if (!hasProp(value, "urls")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'urls'.` };
    }
    const parsed_urls = ((): ParserResult<{
      cover: string;
      list: string;
      reference: string;
    }> => {
      return ((
        value: unknown,
      ): ParserResult<{
        cover: string;
        list: string;
        reference: string;
      }> => {
        if (typeof value !== "object") {
          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls]: '${value}' expected to be of type 'object'.` };
        }
        if (value === null) {
          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls]: '${value}' expected to not be null.` };
        }
        if (!hasProp(value, "cover")) {
          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/cover]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'cover'.` };
        }
        const parsed_cover = ((): ParserResult<string> => {
          return ((value: unknown): ParserResult<string> => {
            if (typeof value !== "string") {
              return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/cover]: '${value}' expected to be of type string.` };
            }
            return { success: true, value: value };
          })(value["cover"]);
        })();
        if (!parsed_cover.success) {
          return { success: false, reason: parsed_cover.reason };
        }
        if (!hasProp(value, "list")) {
          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/list]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'list'.` };
        }
        const parsed_list = ((): ParserResult<string> => {
          return ((value: unknown): ParserResult<string> => {
            if (typeof value !== "string") {
              return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/list]: '${value}' expected to be of type string.` };
            }
            return { success: true, value: value };
          })(value["list"]);
        })();
        if (!parsed_list.success) {
          return { success: false, reason: parsed_list.reason };
        }
        if (!hasProp(value, "reference")) {
          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/reference]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'reference'.` };
        }
        const parsed_reference = ((): ParserResult<string> => {
          return ((value: unknown): ParserResult<string> => {
            if (typeof value !== "string") {
              return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/reference]: '${value}' expected to be of type string.` };
            }
            return { success: true, value: value };
          })(value["reference"]);
        })();
        if (!parsed_reference.success) {
          return { success: false, reason: parsed_reference.reason };
        }
        return { success: true, value: { cover: parsed_cover.value, list: parsed_list.value, reference: parsed_reference.value } };
      })(value["urls"]);
    })();
    if (!parsed_urls.success) {
      return { success: false, reason: parsed_urls.reason };
    }
    return {
      success: true,
      value: {
        bookmarked: parsed_bookmarked.value,
        dataId: parsed_dataId.value,
        rating: parsed_rating.value,
        referenceNumber: parsed_referenceNumber.value,
        snippet: parsed_snippet.value,
        sourceTypeString: parsed_sourceTypeString.value,
        title: parsed_title.value,
        urls: parsed_urls.value,
      },
    };
  })(value);
}
export function deserialize_AskGetabstractAnswerContextDoc(str: string): ParserResult<AskGetabstractAnswerContextDoc> {
  return deserialize_AskGetabstractAnswerContextDoc_internal(parseJsonWithNumbersAsBigint(str));
}
